import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  FHRLogoIcon, PageHeaderCaption, THCLogoIcon, sanitize,
} from '@americanexpress/consumer-travel-base';
import styles from './BenefitCards.scss';
import IndividualBenefit from './Benefit';

const BenefitCard = ({ benefitType, content, extraPaddingRequired }) => {
  const {
    imageURL, imageAttribution, bodyText, benefits,
  } = content;
  const filteredBenefits = benefits.filter((benefit) => benefit.displayed);

  const logoIcons = {
    FHR: <FHRLogoIcon className={`${styles.fhrWidth}`} />,
    THC: <THCLogoIcon className={`${styles.hotelLogo}`} />,
  };

  const backgroundThemes = {
    FHR: 'dls-gray-06-bg',
    THC: 'dls-deep-blue-bg',
  };

  return (
    <div className={clsx('flex-item-grow', styles.contentWrapper)}>
      <div
        className={clsx('flex-column position-relative', styles.travelCreditImages)}
        style={{ backgroundImage: `url(${imageURL})` }}
      >
        <PageHeaderCaption
          captionText={imageAttribution}
          displayCaptionInAllViewPorts={true}
          styledTextBackground={`${benefitType}Theme`}
        />
      </div>
      <div className={`${backgroundThemes[benefitType]} text-align-center pad-3-lr pad-2-b pad-3-t`}>
        {logoIcons[benefitType]}
        <div
          className="pad-2-b body-1 pad-1-t"
          /* eslint-disable-next-line react/no-danger -- content from oneCMS */
          dangerouslySetInnerHTML={{ __html: sanitize(bodyText, { html: true }) }}
        />
        <div className={`text-align-left margin-${extraPaddingRequired}-tb pad-${extraPaddingRequired}-tb`}>
          {
            filteredBenefits?.map((benefit) => (
              <IndividualBenefit
                key={benefit.id}
                benefitDetails={benefit}
              />
            ))
          }
        </div>
      </div>
    </div>
  );
};

BenefitCard.propTypes = {
  benefitType: PropTypes.string.isRequired,
  content: PropTypes.shape({
    imageURL: PropTypes.string,
    imageAttribution: PropTypes.string,
    bodyText: PropTypes.string,
    benefits: PropTypes.arrayOf(PropTypes.shape({
      displayed: PropTypes.bool,
    })),
  }).isRequired,
  extraPaddingRequired: PropTypes.number.isRequired,
};

export default BenefitCard;
